import React from 'react'

export const GlobalLoadIndicator = React.createContext();